export const WAEC_BIOLOGY = [
  {
    q: "What is the powerhouse of the cell?",
    o: ["Nucleus", "Ribosome", "Mitochondrion", "Golgi body"],
    a: 2,
    e: "Mitochondria produce ATP through cellular respiration, providing energy for the cell.",
    h: "Where ATP is made.",
    yr: "2023",
  },
  {
    q: "Which blood group is the universal donor?",
    o: ["A", "B", "AB", "O"],
    a: 3,
    e: "Blood group O has no A or B antigens, so it can donate to any group.",
    h: "No antigens on the red blood cells.",
    yr: "2022",
  },
  {
    q: "Osmosis is the movement of water molecules from a region of:",
    o: ["High solute to low solute", "Low water potential to high water potential", "High water potential to low water potential", "High pressure to low pressure"],
    a: 2,
    e: "Osmosis moves water from high water potential (dilute solution) to low water potential (concentrated solution) through a semi-permeable membrane.",
    h: "Water moves down its own concentration gradient.",
    yr: "2023",
  },
  {
    q: "The basic unit of heredity is called a:",
    o: ["Chromosome", "Gene", "Nucleus", "DNA"],
    a: 1,
    e: "Genes are the basic units of heredity, located on chromosomes. They carry information for specific traits.",
    h: "Smaller than a chromosome.",
    yr: "2021",
  },
  {
    q: "Which organ produces insulin?",
    o: ["Liver", "Kidney", "Pancreas", "Spleen"],
    a: 2,
    e: "The islets of Langerhans in the pancreas produce insulin, which regulates blood glucose.",
    h: "Think of diabetes treatment.",
    yr: "2022",
  },
];

export const WAEC_BIOLOGY_LEARN = [
  {
    topic: "Cell Structure",
    content: "Plant cells have: cell wall, chloroplasts, large central vacuole. Animal cells have: centrioles, smaller vacuoles. Both have: nucleus, mitochondria, ribosomes, endoplasmic reticulum, Golgi apparatus, cell membrane. Prokaryotes (bacteria) have no membrane-bound nucleus.",
  },
  {
    topic: "Photosynthesis",
    content: "6CO₂ + 6H₂O + light energy → C₆H₁₂O₆ + 6O₂. Occurs in chloroplasts. Two stages: Light-dependent reactions (in thylakoids) produce ATP and NADPH. Light-independent reactions / Calvin cycle (in stroma) use ATP and NADPH to fix CO₂ into glucose.",
  },
  {
    topic: "Genetics & Inheritance",
    content: "Mendel's Laws: Segregation (alleles separate during gamete formation) and Independent Assortment. Dominant alleles mask recessive ones. Genotype = genetic makeup (AA, Aa, aa). Phenotype = physical expression. Codominance: both alleles expressed equally (e.g. blood group AB).",
  },
  {
    topic: "Human Nutrition",
    content: "Carbohydrates: energy source (glucose, starch). Proteins: growth and repair (amino acids). Fats: energy reserve, insulation. Vitamins: regulatory functions (A, B, C, D, E, K). Minerals: structural and regulatory (Ca, Fe, Na, K). Water: transport medium, temperature regulation.",
  },
  {
    topic: "Ecology",
    content: "Ecosystem = biotic (living) + abiotic (non-living) components. Food chain: Producer → Primary consumer → Secondary consumer → Tertiary consumer. Energy is lost at each trophic level (~90%). Decomposers recycle nutrients. Biomes: tropical rainforest, savanna, desert, tundra, etc.",
  },
];
